<template>
  <div class="satelliteDataApply">
      <Header/>
        <iframe :src="url" frameborder="0" style="width:100%;min-height:785px;"></iframe>
      <Footer/>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"
    import axios from 'axios'
export default {
    name:'satelliteDataApply',
    components: {
        Header,
        Footer
    },
    data(){
        return{
            url:"http://120.196.115.131:30883/algorithmschedule"
        }
    },
    watch:{
    },
    methods:{
    },
    created(){
        axios.get('config/iframeConfig.json').then(res => {
            this.url = res.algorithmScheduling
            if (res.data) {
                this.url = res.data.algorithmScheduling
            }
        })
    },
    mounted(){
        window.addEventListener('message', (event) => {
            if(event.data.routerId){
                this.$router.push({
                    path:'/algorithmdetail',
                    query:{
                        ProductId:event.data.routerId
                    }
                })
            }
        });
    }
}
</script>

<style lang="scss" scoped>
.current-loc{
    height: 21px;
    display: flex;
    font-size: 16px;
    align-items: center;
    margin-top: 30px;
    .n1{
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FEFCFC;
    }
    .n-right{
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FEFCFC;
        margin: 0 3px;
    }
    .n2{
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(2, 105, 255, 1);
        cursor: pointer;
    }
}
.satelliteDataApply{
    width: 100%;
    color: white;
    background-color: rgba(10, 12, 29, 1);
    .content{
        min-height: 785px;
        width: 1551px;
        margin: 0 auto;
        .query{
            display: flex;
            align-items: center;
            font-size: 15px;
            margin: 33px 0 5px 0;
            .query-box{
                display: flex;
                justify-content: space-between;
                flex: 1;
            }
            .query-site{
                display: flex;
                flex: 1;
                align-items: center;
                span{
                    font-size: 16px;
                    margin-right: 8px;
                }
            }
        }
        .data-table{
            margin: 20px 0;
        }
        .pagenation{
            display: flex;
            justify-content: center;
            padding-right: 0;
            margin: 40px 0 20px 0;
            &-left{
                display: flex;
                align-items: center;
            }
        }
        .new-apply{
            font-size: 13px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            .new-t{
                display: flex;
                align-items: center;
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #0269FF;
                margin:38px 0 18px 0;
                .clolr-kuai{
                    margin-right: 6px;
                    width: 5px;
                    height: 17px;
                    background: #0269FF;
                }
            }
            .xuxian{
                width: 100%;
                height: 1px;
                background-image: linear-gradient(to right, #3c3e4d 0%, #3c3e4d 50%, transparent 50%);
                background-size: 28px 1px;
                background-repeat: repeat-x;
            }
            .zhongjian{
                display: flex;
                justify-content: space-between;
                .left,.zhong,.right{
                    width: 380px;
                    .form-site{
                        margin-top: 23px;
                    }
                }
            }
            .map-title{
                margin-top: 25px;
            }
            .map-box{
                width: 100%;
                height: 484px;
                position: relative;
                .basemap{
                    width: 100%;
                    height: 100%;
                    margin-top: 6px;
                    background: #2D3359;
                    border-radius: 2px;
                }
                .map-tool{
                    width: 27px;
                    background: #FFFFFF;
                    border-radius: 4px;
                    position: absolute;
                    padding: 3px 0;
                    top: 12px;
                    left: 12px;
                    z-index: 500;

                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    span{
                        color: rgba(2, 105, 255, 1);
                        margin: 3px 0;
                    }
                }
            }
            .btn-box{
                height: 36px;
                display: flex;
                justify-content: flex-end;
                margin: 19px 0;
                .btn{
                    width: 100px;
                    height: 34px;
                    border-radius: 5px;
                    border: 1px solid #0269FF;
                    cursor: pointer;
                }
                .cancel-btn{
                    margin-right: 28px;
                    font-size: 18px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #0269FF;
                }
                .cancel-btn:hover{
                    background-color: rgba(2, 105, 255, 0.2);
                }
                .sure-btn{
                    background: #0269FF;
                    font-size: 18px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #FFFFFF;
                }
                .sure-btn:hover{
                    background-color: rgba(2, 105, 255, .8);
                }
            }
            
        }
    }
    ::v-deep .btn-next{
        margin-right: 0;
    }
    ::v-deep .el-pagination{
        padding-right: 0;
    }
}
 /deep/ .el-table-column--selection{
    .cell{
        padding: 0 10px;
    }
}
/deep/ .el-table::before {
    background-color: transparent;
}
/deep/ .input-site{
    width: 100%;
    background: #2D3359;
    border: none;
    margin-top: 5px;
    input{
        background: #2D3359;
        border: none;
    }
    textarea{
        background: #2D3359;
        border: none;
        height: 101px;
    }
}
/deep/ .warning-row {
    background: rgba(16, 31, 67, 1) !important;
}
.view-log{
    width: 76px;
    height: 24px;
    background: #93DBCD;
    border-radius: 4px;
    margin: 0 5px;
    padding: 2px 5px;
    color: white;
}
.view-such{
    width: 76px;
    height: 24px;
    background: #98B8E4;
    border-radius: 4px;
    margin: 0 5px;
    padding: 2px 5px;
    color: white;
}
</style>